/** Hosts that may embed DesignDeck; the API decides everything else from the account. */
export const INTEGRATORS = ['cloud', 'phoenix', 'medusa'] as const;

export type Integrator = (typeof INTEGRATORS)[number];

/** Request header that names the integrator on signed host-to-API calls. */
export const INTEGRATOR_HEADER = 'x-designdeck-integrator';

export function isIntegrator(value: unknown): value is Integrator {
  return (
    typeof value === 'string' &&
    (INTEGRATORS as readonly string[]).includes(value)
  );
}
